export const KEYS = {
  AUTH: 'sms_auth',
  STUDENTS: 'sms_students',
  STAFF: 'sms_staff',
  CLASSES: 'sms_classes',
  SUBJECTS: 'sms_subjects',
  TIMETABLE: 'sms_timetable',
  ATTENDANCE: 'sms_attendance',
  EXAMS: 'sms_exams',
  MARKS: 'sms_marks',
  FEES: 'sms_fee_structures',
  FEE_PAYMENTS: 'sms_fee_payments',
  BOOKS: 'sms_books',
  BOOK_ISSUES: 'sms_book_issues',
  ROUTES: 'sms_routes',
  VEHICLES: 'sms_vehicles',
  ANNOUNCEMENTS: 'sms_announcements',
  HOMEWORK: 'sms_homework',
  NOTIFICATIONS: 'sms_notifications',
  HW_COMPLETIONS: 'sms_hw_completions',
  EXAM_TIMETABLE: 'sms_exam_timetable',
  LESSON_PLANS: 'sms_lesson_plans',
  ENQUIRIES: 'sms_enquiries',
  USERS: 'sms_users',
};
